import { render } from "./ModalUpdateHistoryDelivery.vue?vue&type=template&id=aebde496&scoped=true"
import script from "./ModalUpdateHistoryDelivery.vue?vue&type=script&lang=js"
export * from "./ModalUpdateHistoryDelivery.vue?vue&type=script&lang=js"

import "./ModalUpdateHistoryDelivery.vue?vue&type=style&index=0&id=aebde496&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aebde496"]])

export default __exports__